
import React from 'react';
import { Staff } from '../types';

const LeaveView: React.FC<{ staff: Staff[] }> = ({ staff }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="ymca-brand-font text-4xl">Absence & Leave</h2>
        <div className="flex space-x-2">
          <button className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-bold">Export Report</button>
          <button className="px-6 py-2 bg-ymca-orange text-white rounded-lg font-bold">Request Leave</button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-6 border-b border-gray-100">
          <h3 className="text-lg font-bold">Pending Requests</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-gray-50 text-xs font-bold text-gray-500 uppercase">
                <th className="p-4">Staff Member</th>
                <th className="p-4">Type</th>
                <th className="p-4">Dates</th>
                <th className="p-4">Status</th>
                <th className="p-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: 'Sarah Jenkins', type: 'Holiday', dates: '24 Oct - 28 Oct', status: 'Pending' },
                { name: 'Marcus Thorne', type: 'TOIL', dates: '30 Oct', status: 'Pending' }
              ].map((req, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="p-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 rounded-full bg-ymca-blue/20 text-ymca-blue flex items-center justify-center font-bold text-xs">{req.name[0]}</div>
                      <span className="font-bold text-sm">{req.name}</span>
                    </div>
                  </td>
                  <td className="p-4"><span className="text-sm">{req.type}</span></td>
                  <td className="p-4"><span className="text-sm font-mono">{req.dates}</span></td>
                  <td className="p-4"><span className="px-2 py-1 bg-yellow-100 text-yellow-700 rounded text-[10px] font-bold uppercase">{req.status}</span></td>
                  <td className="p-4 text-right">
                    <button className="text-ymca-green font-bold mr-4 hover:underline">Approve</button>
                    <button className="text-ymca-red font-bold hover:underline">Reject</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeaveView;
